/* prettier-ignore */

import { Component, computed, inject, ViewEncapsulation } from "@angular/core";
import { ToolsService } from "./services/tools.service";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { NavigationService } from "./services/navigation.service";
import { RestService } from "./services/rest.service";
import { AuthService } from "./services/auth.service";
import { ModalController } from "@ionic/angular";
import { UserService } from "./services/user.service";
import { StatisticsService } from "./services/statistics.service";
import { GoogleTranslateService } from "./services/google-translate.service";
import { fadeInAnimation } from './route-animations';
import { CookieService } from "ngx-cookie-service";
import { DebugService } from "./services/debug.service";
import { ChatBotScriptService } from "./services/chatbot.service";
import { WebsocketLaravelReverb } from "./fitur-26/pages/home/services";
import { CHANNEL_DEV_ACTIONS, RESTART, START_TOKEN } from "./fitur-26/pages/home/config/constants";
import { environment } from 'src/environments/environment';
import { CustomRouteService } from "./pages/custom-route/services";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: [ fadeInAnimation ] 
})

export class AppComponent {
  private debugService = inject(DebugService);
  private _customRouteService = inject(CustomRouteService);
  private _websocketLaravelReverbService = inject(WebsocketLaravelReverb);
  
  protected routeToken = this._customRouteService.token;
  
  public isRegisterMode = computed(() => this.tools.isRegisterMode())
  public isAppLoaded = computed(() => this.tools.isAppLoaded());
  public isTechMode = computed(() => this.tools.isTechMode());

  queryParamLang: any;
  chatId: any;

  constructor(
    public modalCtrl: ModalController,
    public translate: TranslateService,
    private router: Router,
    public tools: ToolsService,
    public rest: RestService,
    public navigation: NavigationService,
    public authService: AuthService,
    public userService: UserService,
    public statsService: StatisticsService,
    public googleTranslateService: GoogleTranslateService,
    private cookieService: CookieService,
    private chatService: ChatBotScriptService,
    //private location: Location
  ) {
      this.rest.subDomain = 'madrid' // ! hardcoded for fitur this.tools.getSubdomain(window.location.href);
      this.debugService.info(this.rest.subDomain, '[AppComponent] SUBDOMAIN');
      
      this.tools.setCorporiveColors();

      this._websocketLaravelReverbService.connect();
  }


  ngOnInit(): void {
    this._subscribeToDevChannelRestartAction();
    this._subscribeToDevChannelStartToken();
    
    if (this.rest.subDomain) {
      // COMMON APP REQUEST
      this.rest.getCommonApp(this.statsService.token).subscribe((response) => {
        this.debugService.debug(response, '[AppComponent] Common API Response');

        if (response.error) {
          // TODO: ver como renderizamos esta pagina de error
          this.router.navigateByUrl("not-found");
          return;
        }

        this.rest.setDevice(response);
        this.debugService.debug(this.rest.device, '[AppComponent] Device Info');
        this.enableChat(response);
      });
    } 
  }

  enableChat(response){
    this.rest.device.chatBotId = response?.lang?.chatbot;
    this.rest.device.chatBotStandalone = response?.newVersion === 1;
    const mainLang = this.rest.device.mainLanguage ? this.rest.device.mainLanguage : "es";
    const newChat =  this.cookieService.get('newChat');
    console.log('newChat', this.rest.device.chatBotId, this.rest.device.chatBotStandalone, newChat);
    if (this.rest.device.chatBotId && (this.rest.device.chatBotStandalone || newChat === 'true')){
      this.chatId = this.rest.device.chatBotId;
      this.chatService.chatId.set(this.chatId);
      return;
    }
   this.chatService.loadChat(mainLang);
  }

  private _subscribeToDevChannelRestartAction(): void {
    this._websocketLaravelReverbService
      .subscribeToChannel(CHANNEL_DEV_ACTIONS, RESTART)
      .subscribe({
        next: (data: any) => {
          window.location.replace(environment.urlImmersive);
        },
        error: (err: any) => console.error('Error en canal:', err)
      });
  }

  private _subscribeToDevChannelStartToken(): void {
    this._websocketLaravelReverbService
      .subscribeToChannel(CHANNEL_DEV_ACTIONS, START_TOKEN)
      .subscribe({
        next: (data: any) => {
          console.log(data);
          const token = data?.[0]?.token;
          if (!token)
            return;

          window.location.replace(`${environment.urlImmersive}/home/route/${token}`);
        },
        error: (err: any) => console.error('Error en canal:', err)
      });
  }

  
}

